import { formatEST, formatTime, formatShortTime } from "../address/FormatTime";

export const getNext14DaysAndTimes = (props, storeContext) => {
    const defaultStartTime = "00:00:00";
    const defaultEndTime = "00:00:00";

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1); // Set to tomorrow

    // Get today's date
    const today = new Date();

    // Create and filter the 14-day window with times
    const next14DaysWithTimes = [...Array(14)].map((_, index) => {
        const date = new Date(today);
        date.setDate(today.getDate() + index);
        const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'long' });

        return {
            date,
            dayOfWeek,
            dateReadable: date.toLocaleDateString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            }),
            dateString: date.toISOString().slice(0, 10),
            mysqlDate: date.toISOString().split('.')[0] + 'Z',
            startTimePickup: defaultStartTime,
            endTimePickup: defaultEndTime,
            startTimeDelivery: defaultStartTime,
            endTimeDelivery: defaultEndTime
        }
    }).filter(day =>
        !storeContext.storeClosures.some(closure =>
            closure.dateClosed.includes(day.dateString)
        )
    );

    var removeClosedDays;

    if (props.orderType === "Delivery") {
        removeClosedDays = next14DaysWithTimes.filter(day => {
            const matchingHour = storeContext.deliveryHours.find(hour =>
                hour.dayOfWeek === day.dayOfWeek &&
                hour.openTime !== "00:00:00" &&
                hour.closeTime !== "00:00:00"
            );
            return !!matchingHour;
        });
    } else {
        removeClosedDays = next14DaysWithTimes.filter(day => {
            const matchingHour = storeContext.hours.find(hour =>
                hour.dayOfWeek === day.dayOfWeek &&
                hour.openTime !== "00:00:00" &&
                hour.closeTime !== "00:00:00"
            );
            return !!matchingHour;
        });
    }


    for (var i = 0; i < removeClosedDays.length; i++) {
        for (var j = 0; j < storeContext.hours.length; j++) {
            //pick up hours
            if (removeClosedDays[i].dayOfWeek === storeContext.hours[j].dayOfWeek) {
                removeClosedDays[i].startTimePickup = storeContext.hours[j].openTime;
                removeClosedDays[i].endTimePickup = storeContext.hours[j].closeTime;
            }

            //delivery hours
            if (removeClosedDays[i].dayOfWeek === storeContext.deliveryHours[j].dayOfWeek) {
                removeClosedDays[i].startTimeDelivery = storeContext.deliveryHours[j].openTime;
                removeClosedDays[i].endTimeDelivery = storeContext.deliveryHours[j].closeTime;
            }
        }
    }

    return removeClosedDays;
}


export const getTimeSlots = (orderType, data) => {
    const newTimeSlots = [];
    const timeFormat = "HH:mm";
    var start;
    var end;
    if (orderType === "Delivery") {
        start = data.startTimeDelivery;
        end = data.endTimeDelivery;
    } else {
        start = data.startTimePickup;
        end = data.endTimePickup;
    }

    const timeToMinutes = (timeStr) => {
        const [hours, minutes] = timeStr.split(":").map(Number);
        return hours * 60 + minutes;
    };

    const formatTimeSlot = (minutesTotal) => {
        const hours = Math.floor(minutesTotal / 60);
        const mins = minutesTotal % 60;

        const hh = hours.toString().padStart(2, '0');
        const mm = mins.toString().padStart(2, '0');

        const ampmHour = ((hours + 11) % 12 + 1);
        const ampm = hours < 12 ? "am" : "pm";
        const timeFormatted = `${ampmHour}:${mm} ${ampm}`;

        return {
            est: `${hh}:${mm}:00.00Z`,
            shortTime: `${hh}:${mm}`,
            time: timeFormatted
        };
    };

    let current = timeToMinutes(start);
    const endMinutes = timeToMinutes(end);

    while (current <= endMinutes) {
        newTimeSlots.push(formatTimeSlot(current));
        current += 15;
    }

    return newTimeSlots;
};
